<template>
    <div class="form-elements">
        <div class="row">
            <div class="col-md-12">
                <vuestic-widget headerText="Câmeras">
                  <FormCams></FormCams>
                </vuestic-widget>
            </div>
        </div>
    </div>
</template>

<script>
import FormCams from './FormCams'
export default {
  name: 'form-cameras-edicao',
  components: {
    FormCams
  }
}
</script>
